// @flow
import NotEnoughLink from './NotEnoughLink';

export default NotEnoughLink;
